export { default } from './IconAffix';
